<template>
  <div>
    <h3 class="h-title">存储方基本信息</h3>
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="160px"  label-position="left" :rules="setpFormRules2">
      <el-form-item label="存储方名称" prop="submitName">
        <el-input v-model="cForm2.submitName" disabled/>
      </el-form-item>
      <el-form-item label="会员编号" prop="createBy">
        <el-input v-model="cForm2.createBy" disabled />
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="socialCreditCode">
        <el-input v-model="cForm2.socialCreditCode" disabled />
      </el-form-item>
      <el-form-item label="法定代表人名称" prop="legalName">
        <el-input v-model="cForm2.legalName" disabled />
      </el-form-item>
      <el-form-item label="注册地址" prop="registerAddressArr">
        <el-cascader disabled
            ref="cascaderArr"
            style="width: 100%"
            v-model="cForm2.registerAddressArr"
            :options="areaOptions">
        </el-cascader>
      </el-form-item>
      <el-form-item label="注册资本金(万元)" prop="registerCapital">
        <el-input v-model="cForm2.registerCapital" disabled />
      </el-form-item>
      <el-form-item label="主体类型" prop="subjectType">
        <el-select v-model="cForm2.subjectType" disabled placeholder="请选择" style="width: 100%"> 
            <el-option
              v-for="dict in subjectTypeOptions"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            ></el-option>
        </el-select> 
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactsName">
        <el-input v-model="cForm2.contactsName" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactsTel">
        <el-input v-model="cForm2.contactsTel" :maxlength="11" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="治理服务指定邮箱" prop="saveMail">
        <el-input v-model="cForm2.saveMail" placeholder="请输入" />
      </el-form-item>
      
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import area from '@/utils/area';
import { elFormErrorScrollIntoView } from '@/utils/util'

export default {
  name: "step2",
  props: ["active"],
  data() {
    return {
      file: '',
      butLoading: false,
      cForm2: {},
      // 表单校验
      setpFormRules2: {
        contactsName: [
                { required: true, message: "联系人不能为空", trigger: "blur" }
            ],
        contactsTel: [
            { required: true, message: "联系人手机号不能为空", trigger: "blur" 	},
            {
                pattern: /^1[0-9][0-9]\d{8}$/,
                message: "请输入正确的手机号码",
                trigger: "blur"
            },   
        ],
        saveMail:[
            {
            required: true,
            pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱",
            trigger: "blur"
            },
        ]
      },
      areaOptions:area,
      userInf: {},
      subjectTypeOptions: []
    }
  },
  watch: {
    active(newVal) {
      if(newVal == 2) {
        window.scrollTo(0,0);
        this.cForm2 = JSON.parse(sessionStorage.setpForm);
        this.userInf = JSON.parse(sessionStorage.userInf)
        this.cForm2.submitName = this.userInf.companyCn
        this.cForm2.createBy = this.userInf.account
        this.cForm2.socialCreditCode = this.userInf.job
        this.cForm2.legalName = this.userInf.legalPerson
        this.cForm2.registerAddressArr = [this.userInf.compProvinceCode, this.userInf.compCityCode, this.userInf.compDistrictCode]
        this.cForm2.registerCapital = this.userInf.regCapital           
        this.cForm2.subjectType = this.userInf.userType
        
        this.$set(this.cForm2, 'contactsName', this.cForm2.contactsName || this.userInf.agencyPerson)
        this.$set(this.cForm2, 'contactsTel', this.cForm2.contactsTel || this.userInf.mobile)
        this.$set(this.cForm2, 'saveMail', this.cForm2.saveMail || this.userInf.email)
      }
    }
  },
  created(){
    this.$api.api.getDicts("zqzl_subject_type").then(response => {
        this.subjectTypeOptions = response.data;
    });
  },
  methods: { 
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm2);
      this.$emit('prev')
    },
    cSubmitForm(type){ 
      const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();  
      if(this.cForm2.registerAddressArr){
        this.cForm2.registerAddress = checkedNode[0].pathLabels.join('-')
      }
      if(type == '0'){                  
        this.butLoading = true;
        this.cForm2.status = '0'
        this.$api.creditorsRights.addAndUpd(JSON.stringify(this.cForm2)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }     
        });
        
      }else{
        this.$refs["cForm2"].validate(valid => {
          if (valid) {
            sessionStorage.setpForm = JSON.stringify(this.cForm2);
            this.$emit('next');
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        }) 
      }  
    },
  }
}
</script>
